import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { filter } from "rxjs/operators";
import { NavigationStart, Router } from "@angular/router";
import { UiError } from "../ui-error.factory";
import { LoadingScreenService } from "../loading-screen.service";

@Injectable({
  providedIn: "root"
})
export class UiErrorService {
  private errorSubject = new BehaviorSubject<UiError | null>(null);
  public error$ = this.errorSubject.asObservable();

  constructor(
    private readonly loadingScreen: LoadingScreenService,
    private readonly router: Router
  ) {
    this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(() => this.clear());
  }

  show(error: UiError) {
    this.errorSubject.next(error);
    this.loadingScreen.stopLoading();
  }

  clear() {
    this.errorSubject.next(null);
  }
}